export const FILE_SIZE_LIMIT: number = 8388608; // Upload size limit 8MB

export const BASE_BACKEND_URL = process.env.REACT_APP_API_BASE_URL_DEV_LOCAL;

export const GET_PRESEIGNED_MEDIA_URL = `${process.env.REACT_APP_API_BASE_URL_DEV_LOCAL}/media/presigned`;

export const STAGES = {
    GENERATION: 'Request Generation',
    ASSIGNMENT: 'Request Assignment',
    // QUOTATION: 'Seeking Quotation',
    // APPROVAL: 'Approval',
    CREATION: 'Creation'
};

export const STATUSES = {
    REQUEST_GENERATED: 'Request Generated',
    DRAFT: 'Draft',
    REQUEST_SUBMITTED: 'Request Submitted',
    OPEN_TO_MODIFY: 'Open To Modify',
    REQUEST_SENT: 'Request Sent',

    REVIEW_PENDING: 'Review Pending',
    REVIEW_IN_PROGRESS: 'Review In Progress',
    CREATION_APPROVAL_IN_PROGRESS: 'CREATION_APPROVAL_IN_PROGRESS',
    REQUEST_FLAGGED: 'Request Flagged',
    REVIEW_COMPLETED: 'Review Completed',

    QUOTATION_SENT: 'Quotation Sent',
    BIZ_FIN_APPROVAL_PENDING: 'Biz Fin Approval Pending',
    READY_TO_CREATE: 'Ready To Create',
    REQUEST_TO_BE_PICKED: 'Request To Be Picked',
    CREATION_IN_PROGRESS: 'Creation In Progress',
    COMPLETED: 'Completed',
    ACCEPTED: 'ACCEPTED'
};

export const MODEL_STATUSES = {
    TO_BE_PICKED: 'To be picked',
    CREATION_IN_PROGRESS: 'Creation In Progress',
    APPROVED: 'Approved',
    READY_FOR_REVIEW: 'Ready for Review',
    CHANGES_REQUESTED: 'Changes Requested'
};

export const ROLES_MAPPING = {
    REQUESTOR: 'requester',
    OPS_MANAGER: 'ops',
    THREED_ARTIST: 'vendor',
    ADMIN: 'admin'
};

export const STAGE_COLORS = {
    GENERATION: '#5482FF',
    ASSIGNMENT: '#FFC200',
    QUOTATION: '#FFC200',
    APPROVAL: '#008C00',
    CREATION: '#008C00'
};

export const COMPLEXITIES = {
    SIMPLE: 'SIMPLE',
    MEDIUM: 'MEDIUM',
    HARD: 'HARD'
};

export const SAMPLE_CSV_URL = 'https://static-assets-web.flixcart.com/scale3d-files/sample.csv';

export const LocalKeys = {
    activeRole: 'activeRole'
};

export const TextureConstants = {
    Length: 2048,
    Width: 2048
};
